import { useEffect } from 'react';

export default function ListingPresentationPage() {
  useEffect(() => {
    window.location.href = '/listing-presentation.html';
  }, []);
  return null;
}
